export const IMAGE_UPLOADER_TITLE = 'Upload Image';
export const IMAGE_UPLOADER_SUBTITLE = 'Min 400x400px, PNG or JPEG';
